import { render, staticRenderFns } from "./CloseInfo.vue?vue&type=template&id=3d5f0a9f"
import script from "./CloseInfo.vue?vue&type=script&lang=js"
export * from "./CloseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5f0a9f')) {
      api.createRecord('3d5f0a9f', component.options)
    } else {
      api.reload('3d5f0a9f', component.options)
    }
    module.hot.accept("./CloseInfo.vue?vue&type=template&id=3d5f0a9f", function () {
      api.rerender('3d5f0a9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/CloseInfo.vue"
export default component.exports